import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const BreadcrumbsNav = styled(Box)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    fontWeight: 500,
    color: theme.palette.jigsaw.green,
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    backgroundColor: theme.palette.jigsaw.white,
}));

export const BreadcrumbsContainer = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    width: '100%',
}));

export const BreadcrumbsItem = styled(Box)(({ theme }) => ({
    color: theme.palette.jigsaw.green,
}));

export const BreadcrumbsSeparator = styled(Box)(({ theme }) => ({
    margin: `0 ${theme.spacing(1)}`,
    color: theme.palette.jigsaw.green,
}));